var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMarginaliaDelivery(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 262,
    height: 256,
    viewBox: "0 0 262 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.1467 108.301C33.6832 108.301 34.1181 107.866 34.1181 107.33C34.1181 106.793 33.6832 106.358 33.1467 106.358C32.6102 106.358 32.1753 106.793 32.1753 107.33C32.1753 107.866 32.6102 108.301 33.1467 108.301Z",
    fill: "#BFD9FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M136.567 173.339C137.104 173.339 137.539 172.904 137.539 172.367C137.539 171.831 137.104 171.396 136.567 171.396C136.031 171.396 135.596 171.831 135.596 172.367C135.596 172.904 136.031 173.339 136.567 173.339Z",
    fill: "#BFD9FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M212.385 25.0436C212.921 25.0436 213.356 24.6087 213.356 24.0722C213.356 23.5357 212.921 23.1008 212.385 23.1008C211.848 23.1008 211.414 23.5357 211.414 24.0722C211.414 24.6087 211.848 25.0436 212.385 25.0436Z",
    fill: "#BFD9FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M172.557 55.1812C173.093 55.1812 173.528 54.7463 173.528 54.2098C173.528 53.6733 173.093 53.2384 172.557 53.2384C172.02 53.2384 171.585 53.6733 171.585 54.2098C171.585 54.7463 172.02 55.1812 172.557 55.1812Z",
    fill: "#BFD9FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1179 39.1883C34.6544 39.1883 35.0893 38.7534 35.0893 38.2169C35.0893 37.6804 34.6544 37.2455 34.1179 37.2455C33.5814 37.2455 33.1465 37.6804 33.1465 38.2169C33.1465 38.7534 33.5814 39.1883 34.1179 39.1883Z",
    fill: "#BFD9FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M223.591 114.106C224.088 114.106 224.492 113.703 224.492 113.206C224.492 112.708 224.088 112.305 223.591 112.305C223.094 112.305 222.691 112.708 222.691 113.206C222.691 113.703 223.094 114.106 223.591 114.106Z",
    fill: "#BFD9FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8955 140.121C65.3927 140.121 65.7958 139.718 65.7958 139.221C65.7958 138.723 65.3927 138.32 64.8955 138.32C64.3982 138.32 63.9951 138.723 63.9951 139.221C63.9951 139.718 64.3982 140.121 64.8955 140.121Z",
    fill: "#BFD9FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M117.684 209.423C108.278 209.423 101.904 185.422 87.6882 180.091C73.4724 174.76 58.6879 177.793 54.7075 151.209C52.2434 134.814 41.2498 132.586 31.7015 127.564C25.4465 124.294 17.9595 128.819 17.9595 135.88V210.395L117.684 209.423Z",
    fill: "url(#paint0_linear_7_29222)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1314 209.921C56.6027 209.921 47.2439 199.614 41.4865 194.473C35.7291 189.308 33.8336 194.354 27.9103 188.36C26.3703 186.796 24.9487 185.233 23.7167 183.74C21.7501 181.394 17.9355 182.792 17.9355 185.849V210.418L70.1314 209.921Z",
    fill: "url(#paint1_linear_7_29222)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M145.049 210.418C135.027 210.418 130.288 199.496 124.72 198.074C119.153 196.653 112.874 203.547 119.911 210.418H145.049Z",
    fill: "url(#paint2_linear_7_29222)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M240.319 210.418C216.508 210.418 211.39 189.45 195.516 187.578C174.358 185.09 180.921 176.821 163.198 168.932C156.541 165.97 140.832 172.391 147.229 185.28C150.451 191.796 161.232 209.234 162.108 210.418H240.319Z",
    fill: "url(#paint3_linear_7_29222)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M240.319 209.423H38.8091V210.395H240.319V209.423Z",
    fill: "#2B2B2B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M118.134 51.414C110.528 51.3429 109.58 45.0643 102.946 42.2922C96.3123 39.4964 93.8719 44.9458 85.8873 35.9898C77.9027 27.0338 66.8855 33.739 73.7328 42.2922C76.5522 45.8225 76.7892 50.0635 76.7892 50.0635L118.134 51.414Z",
    fill: "url(#paint4_linear_7_29222)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M130.028 50.9402C130.028 50.9402 122.967 38.0748 114.461 35.8477C105.955 33.6442 104.013 23.6931 97.0706 22.1057C91.6922 20.8736 84.1578 26.1335 89.5125 36.5111C94.8671 46.8886 98.8002 52.1485 98.8002 52.1485L130.028 50.9402Z",
    fill: "url(#paint5_linear_7_29222)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M131.047 50.0872L109.462 97.8525C107.638 101.904 103.586 104.51 99.1559 104.51H72.1457C62.5974 104.51 56.2714 94.6302 60.2755 85.9585L76.8133 50.0398L131.047 50.0872Z",
    fill: "url(#paint6_linear_7_29222)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2353 57.7875H127.587L124.247 65.1323H69.8472L73.2353 57.7875Z",
    fill: "#F9D5FF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M138.581 78.1872L138.723 78.8743L138.842 79.5614L139.079 80.9356C139.221 81.8596 139.339 82.7837 139.458 83.7077C139.576 84.6317 139.671 85.5557 139.766 86.4798L140.026 89.2519C140.358 92.948 140.548 96.6441 140.69 100.34C140.832 104.036 140.856 107.756 140.856 111.452C140.808 115.148 140.737 118.868 140.571 122.588L140.382 127.113L139.221 128.985C136.875 132.776 134.482 136.52 132.018 140.239L130.17 143.035L128.298 145.807C127.066 147.655 125.763 149.48 124.484 151.328C121.901 154.977 119.247 158.625 116.523 162.203C115.149 163.98 113.774 165.781 112.329 167.534L110.173 170.164C109.439 171.04 108.704 171.917 107.946 172.77L92.1426 164.809L116.073 117.328L114.698 123.82L112.59 79.4429L138.581 78.1872Z",
    fill: "url(#paint7_linear_7_29222)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M113.04 89.4414L113.916 107.898L140.832 115.219L140.5 96.1229L113.04 89.4414Z",
    fill: "#2B2B2B"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M117.968 183.266L92.0243 171.964C90.6737 171.372 90.034 169.808 90.579 168.434L91.9295 165.117L108.254 172.415L119.342 180.897C120.646 181.892 119.461 183.906 117.968 183.266Z",
    fill: "#2B2B2B"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M101.644 177.438L94.3936 174.286L95.3413 172.107L101.265 174.689L122.825 156.706L124.342 158.507L101.644 177.438Z",
    fill: "#F9D5FF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M199.804 210.418C175.305 210.418 155.355 190.469 155.355 165.97C155.355 141.471 175.305 121.522 199.804 121.522C224.302 121.522 244.252 141.471 244.252 165.97C244.252 190.469 224.302 210.418 199.804 210.418ZM199.804 123.891C176.608 123.891 157.725 142.775 157.725 165.97C157.725 189.166 176.608 208.049 199.804 208.049C222.999 208.049 241.883 189.166 241.883 165.97C241.883 142.775 222.999 123.891 199.804 123.891Z",
    fill: "#2B2B2B"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0171 210.418C49.5184 210.418 29.5688 190.469 29.5688 165.97C29.5688 141.471 49.5184 121.522 74.0171 121.522C98.5157 121.522 118.465 141.471 118.465 165.97C118.465 190.469 98.5157 210.418 74.0171 210.418ZM74.0171 123.891C50.8215 123.891 31.9382 142.775 31.9382 165.97C31.9382 189.166 50.8215 208.049 74.0171 208.049C97.2126 208.049 116.096 189.166 116.096 165.97C116.096 142.775 97.2126 123.891 74.0171 123.891Z",
    fill: "#2B2B2B"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M123.583 158.27C123.418 158.27 123.228 158.222 123.062 158.151C122.707 157.986 122.446 157.63 122.399 157.251L116.452 112.637C116.404 112.305 116.499 111.95 116.736 111.689C116.949 111.429 117.281 111.286 117.636 111.286H176.751C177.225 111.286 177.651 111.571 177.841 111.997L182.248 122.233C182.484 122.778 182.271 123.417 181.774 123.725L124.199 158.104C124.01 158.222 123.797 158.27 123.583 158.27ZM118.987 113.656L124.507 155.142L179.641 122.209L175.945 113.632H118.987V113.656Z",
    fill: "#F9D5FF"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M199.804 172.367C203.337 172.367 206.201 169.503 206.201 165.97C206.201 162.437 203.337 159.573 199.804 159.573C196.271 159.573 193.407 162.437 193.407 165.97C193.407 169.503 196.271 172.367 199.804 172.367Z",
    fill: "#2B2B2B"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M199.803 173.552C195.633 173.552 192.222 170.14 192.222 165.97C192.222 161.8 195.633 158.388 199.803 158.388C203.973 158.388 207.385 161.8 207.385 165.97C207.385 170.14 203.973 173.552 199.803 173.552ZM199.803 160.758C196.937 160.758 194.591 163.103 194.591 165.97C194.591 168.837 196.937 171.183 199.803 171.183C202.67 171.183 205.016 168.837 205.016 165.97C205.016 163.103 202.67 160.758 199.803 160.758Z",
    fill: "#2B2B2B"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0172 172.367C77.5503 172.367 80.4144 169.503 80.4144 165.97C80.4144 162.437 77.5503 159.573 74.0172 159.573C70.4842 159.573 67.6201 162.437 67.6201 165.97C67.6201 169.503 70.4842 172.367 74.0172 172.367Z",
    fill: "#2B2B2B"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0168 173.552C69.8469 173.552 66.4351 170.14 66.4351 165.97C66.4351 161.8 69.8469 158.388 74.0168 158.388C78.1868 158.388 81.5986 161.8 81.5986 165.97C81.5986 170.14 78.1868 173.552 74.0168 173.552ZM74.0168 160.758C71.15 160.758 68.8044 163.103 68.8044 165.97C68.8044 168.837 71.15 171.183 74.0168 171.183C76.8837 171.183 79.2293 168.837 79.2293 165.97C79.2293 163.103 76.8837 160.758 74.0168 160.758Z",
    fill: "#2B2B2B"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M199.804 167.155C199.354 167.155 198.903 166.894 198.714 166.444L167.794 94.7013L166.041 90.8156C164.667 87.7592 164.951 84.2526 166.752 81.4568C168.576 78.6374 171.656 76.9789 174.997 76.9789C178.954 76.9789 182.484 79.3245 184.024 82.9732L186.559 88.9439C186.82 89.5362 186.536 90.247 185.943 90.5076C185.351 90.7682 184.64 90.4839 184.38 89.8916L181.868 83.8735C180.707 81.1251 178.006 79.3245 175.021 79.3245C172.486 79.3245 170.14 80.6039 168.766 82.7363C167.392 84.8687 167.178 87.5223 168.221 89.8442L169.974 93.7536L200.894 165.52C201.154 166.112 200.87 166.823 200.278 167.084C200.112 167.131 199.97 167.155 199.804 167.155Z",
    fill: "#F9D5FF"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0171 167.155C73.6143 167.155 73.2115 166.942 72.9983 166.562C72.7377 166.136 72.785 165.591 73.093 165.212L116.712 111.713C117.02 111.358 117.494 111.192 117.944 111.31C118.394 111.429 118.726 111.831 118.797 112.305L124.744 156.919C124.839 157.559 124.412 158.128 123.773 158.246L74.2066 167.131C74.1592 167.155 74.0882 167.155 74.0171 167.155ZM116.831 115.338L76.955 164.241L122.256 156.114L116.831 115.338Z",
    fill: "#F9D5FF"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M123.583 168.932C129.838 168.932 134.908 163.861 134.908 157.606C134.908 151.352 129.838 146.281 123.583 146.281C117.328 146.281 112.258 151.352 112.258 157.606C112.258 163.861 117.328 168.932 123.583 168.932Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M123.583 170.116C116.689 170.116 111.073 164.501 111.073 157.606C111.073 150.712 116.689 145.096 123.583 145.096C130.478 145.096 136.093 150.712 136.093 157.606C136.093 164.501 130.478 170.116 123.583 170.116ZM123.583 147.466C117.992 147.466 113.443 152.015 113.443 157.606C113.443 163.198 117.992 167.747 123.583 167.747C129.175 167.747 133.724 163.198 133.724 157.606C133.724 152.015 129.175 147.466 123.583 147.466Z",
    fill: "#F9D5FF"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M116.505 99.3737L116.433 113.211L118.802 113.223L118.874 99.386L116.505 99.3737Z",
    fill: "#F9D5FF"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M129.507 101.217H129.483L105.719 100.933C104.416 100.909 103.373 99.8427 103.373 98.5396C103.397 97.2364 104.463 96.1939 105.766 96.1939L129.53 96.4783C130.833 96.502 131.876 97.5681 131.876 98.8713C131.852 100.174 130.81 101.217 129.507 101.217Z",
    fill: "#F9D5FF"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M169.287 75.344L174.286 73.9698C177.793 72.9984 181.442 75.0834 182.389 78.59C183.242 81.6701 181.726 84.845 178.978 86.2429L174.689 88.3989",
    fill: "#EA7068"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M174.665 88.399L155.711 97.8762C151.896 99.7717 147.324 98.4211 145.144 94.8672L144.694 94.109L129.743 69.6814C127.113 65.393 128.464 59.7777 132.752 57.1478C137.041 54.5178 142.656 55.8683 145.286 60.1568L160.26 84.5844L149.219 80.8172L169.287 75.3441",
    fill: "url(#paint8_linear_7_29222)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M141.069 87.4986C143.96 78.7321 137.799 77.1447 142.064 72.027C146.329 66.9093 146.4 57.7637 139.671 55.5366C134.482 53.8307 134.198 53.499 131.994 52.7645C125.076 50.49 115.054 54.968 114.841 62.2654C114.841 62.2654 110.552 70.1552 108.562 76.1733L141.069 87.4986Z",
    fill: "url(#paint9_linear_7_29222)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M141.969 72.9984C141.874 72.9984 141.779 72.951 141.708 72.88C141.59 72.7378 141.59 72.5009 141.732 72.3824C144.196 70.25 144.22 67.1699 144.22 67.1225C144.22 66.933 144.385 66.7671 144.575 66.7671C144.765 66.7671 144.93 66.933 144.93 67.1225C144.93 67.2647 144.907 70.558 142.206 72.9036C142.135 72.9747 142.064 72.9984 141.969 72.9984Z",
    fill: "#2B2B2B"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M108.585 76.1733C107.045 80.7934 109.604 89.3229 117.66 92.0713L124.223 94.0616C131.544 96.5493 139.623 91.9529 141.282 86.9773L108.585 76.1733Z",
    fill: "#4C7DE0"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M155.379 37.5062L156.161 42.9793C156.469 45.1117 154.811 47.0308 152.631 47.0308H148.342L155.379 37.5062Z",
    fill: "#2B2B2B"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M144.054 51.6272L138.107 49.3053C135.027 48.097 133.51 44.6378 134.695 41.5577L138.202 32.578C140.121 27.6498 145.665 25.2094 150.593 27.1286C155.521 29.0477 157.962 34.5919 156.043 39.5201L152.844 47.7416C151.47 51.2481 147.537 52.9777 144.054 51.6272Z",
    fill: "#EA7068"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M155.426 41.1312L154.645 43.1214C154.337 42.9319 154.147 42.6002 154.147 42.1974C154.147 41.6051 154.645 41.1075 155.237 41.1075C155.308 41.1075 155.355 41.1075 155.426 41.1312Z",
    fill: "#2B2B2B"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M138.202 60.5121L143.841 58.7589C143.841 58.7589 141.163 54.8732 138.202 55.039V60.5121Z",
    fill: "black"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M135.406 59.9672L128.867 54.1861L136.283 37.5299L145.784 41.226L139.979 58.7352C139.339 60.6543 136.922 61.3177 135.406 59.9672Z",
    fill: "#EA7068"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M151.707 44.3061C151.565 44.3061 151.423 44.1876 151.399 44.0454C151.375 43.8796 151.494 43.7137 151.66 43.69L152.655 43.5242C152.773 43.4768 152.868 43.4057 152.915 43.311C152.963 43.2162 152.986 43.0977 152.939 42.9792L152.252 40.989C152.205 40.8232 152.276 40.6573 152.442 40.5862C152.607 40.5389 152.773 40.6099 152.844 40.7758L153.531 42.766C153.626 43.0266 153.602 43.311 153.484 43.5716C153.342 43.8322 153.105 44.0217 152.844 44.1165H152.797L151.778 44.2824C151.731 44.3061 151.731 44.3061 151.707 44.3061Z",
    fill: "#2B2B2B"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M142.514 51.0112L138.652 49.5186L141.234 54.9206L142.514 51.0112Z",
    fill: "#2B2B2B"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M149.432 41.0601C150.034 41.0601 150.522 40.5721 150.522 39.9702C150.522 39.3683 150.034 38.8803 149.432 38.8803C148.83 38.8803 148.342 39.3683 148.342 39.9702C148.342 40.5721 148.83 41.0601 149.432 41.0601Z",
    fill: "#2B2B2B"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M109.912 72.643L122.754 72.8089C122.754 72.8089 127.398 74.2541 128.322 74.4911C128.322 74.4911 159.786 84.9871 163.293 86.4324L165.401 87.309C171.182 89.702 174.002 96.265 171.846 102.094C170.306 106.264 168.718 110.433 167.06 114.556L164.525 120.764C163.672 122.825 158.222 135.122 156.256 139.173C155.261 141.211 154.266 143.225 153.223 145.239L151.636 148.248C151.091 149.243 150.546 150.238 149.977 151.233L132.894 146.589L146.85 95.2936L155.521 111.144L115.29 98.5159C107.685 96.1229 103.752 87.7355 106.761 80.367L109.912 72.643Z",
    fill: "url(#paint10_linear_7_29222)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M149.74 97.9709L171.633 93.4929C171.633 93.4929 170.614 90.7208 167.771 88.6358L149.74 97.9709Z",
    fill: "#2B2B2B"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M162.724 157.156L134.766 152.868C133.297 152.655 132.278 151.304 132.468 149.835L132.918 146.281L150.57 149.172L163.459 154.526C164.975 155.166 164.335 157.417 162.724 157.156Z",
    fill: "#2B2B2B"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M119.982 65.1323C117.423 68.6626 117.541 73.4723 120.266 76.8604L137.609 98.3263C138.984 100.009 141.187 100.743 143.296 100.222L152.252 96.9047L124.981 70.5106L119.982 65.1323Z",
    fill: "#2B2B2B"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M104.297 87.8303L104.226 83.0917C110.931 82.9969 129.435 81.0541 134.387 73.3538C137.42 68.6389 134.884 65.156 130.312 60.0146C127.682 57.0293 125.194 54.2335 125.194 50.9402H129.933C129.933 52.4328 131.923 54.6837 133.866 56.8634C135.927 59.1853 138.249 61.8153 139.505 64.848C141.068 68.6152 140.689 72.335 138.367 75.9127C135.192 80.8171 128.44 84.3237 118.228 86.2902C110.954 87.7118 104.581 87.8303 104.297 87.8303Z",
    fill: "#2B2B2B"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M170.472 74.0409L176.182 72.5482C179.712 71.6242 183.29 73.7329 184.214 77.2632C185.043 80.4617 183.361 83.7314 180.399 84.9871L176.087 86.8115",
    fill: "#EA7068"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M176.111 86.8115L147.987 98.7054C144.457 100.198 140.453 99.0371 138.226 96.1465L137.847 95.649L116.381 67.8333C113.301 63.8529 114.035 58.1191 118.039 55.039C122.02 51.9589 127.753 52.6934 130.834 56.6975L152.3 84.5132L142.135 81.4568L170.496 74.0646",
    fill: "url(#paint11_linear_7_29222)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M156.493 37.9089L156.706 34.4971C156.919 31.2749 154.953 28.3132 151.92 27.2471L148.342 25.9913C145.949 25.1384 143.296 25.6359 141.353 27.2707C140.5 27.9815 139.837 28.8819 139.386 29.877L138.652 31.5829L156.493 37.9089Z",
    fill: "#F9D5FF"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M138.202 32.578L156.279 38.904L159.289 37.8615C161.824 36.9849 161.966 33.4546 159.502 32.3648C158.744 32.0331 157.891 32.0331 157.132 32.3648L151.375 34.8762L139.055 30.7062L138.202 32.578Z",
    fill: "#4C7DE0"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M146.02 35.3027L139.481 41.0601C138.51 41.9131 137.159 42.2448 135.88 41.8894C132.705 41.0127 131.994 36.8191 134.719 34.9473L138.202 32.5543L146.02 35.3027Z",
    fill: "#2B2B2B"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M153.792 45.3012L151.28 44.3061C149.858 43.7611 148.295 43.8085 146.921 44.4719L144.812 45.4907L141.684 37.9089L138.036 41.8657L138.628 49.4949L144.67 51.7931C147.726 52.954 151.185 51.4851 152.441 48.4524L153.792 45.3012Z",
    fill: "#2B2B2B"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M151.707 46.8886C151.707 46.8886 149.456 49.4949 148.39 45.7988L151.707 46.8886Z",
    fill: "white"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M143.557 107.732C143.533 107.732 143.486 107.732 143.462 107.709C143.272 107.661 143.154 107.472 143.201 107.282L144.22 103.515C144.268 103.326 144.457 103.207 144.647 103.254C144.836 103.302 144.955 103.491 144.907 103.681L143.888 107.448C143.865 107.638 143.723 107.732 143.557 107.732Z",
    fill: "#2B2B2B"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M151.257 83.5419C151.162 83.5419 151.043 83.4945 150.972 83.3997L136.14 64.1846C136.022 64.0188 136.046 63.8055 136.212 63.687C136.377 63.5686 136.591 63.5923 136.709 63.7581L151.541 82.9732C151.659 83.1391 151.636 83.3523 151.47 83.4708C151.399 83.5182 151.328 83.5419 151.257 83.5419Z",
    fill: "#2B2B2B"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M113.964 129.814C113.774 129.814 113.608 129.649 113.608 129.459V121.451C113.608 121.261 113.774 121.095 113.964 121.095C114.153 121.095 114.319 121.261 114.319 121.451V129.459C114.319 129.649 114.153 129.814 113.964 129.814Z",
    fill: "#2B2B2B"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9385 35.7529C53.4989 35.7529 56.0341 32.0094 47.8126 30.3745C41.0363 29.024 43.7373 22.39 47.8362 23.4562C56.1999 25.6122 56.8159 29.1188 63.2841 29.4031C66.767 29.569 66.9092 35.7529 60.9385 35.7529Z",
    fill: "url(#paint12_linear_7_29222)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M123.962 158.72L123.204 156.493L136.33 151.896L148.556 154.195L148.129 156.517L136.52 154.361L123.962 158.72Z",
    fill: "#F9D5FF"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M136.425 133.747C136.401 133.747 136.354 133.747 136.33 133.724C136.141 133.676 136.022 133.487 136.093 133.297L140.097 118.821C140.145 118.631 140.334 118.513 140.524 118.584C140.713 118.631 140.832 118.821 140.761 119.01L136.757 133.487C136.733 133.653 136.591 133.747 136.425 133.747Z",
    fill: "#2B2B2B"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M178.294 110.026L173.939 111.896L178.988 123.653L183.343 121.783L178.294 110.026Z",
    fill: "#F9D5FF"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M236.883 101.549C232.097 101.549 224.421 95.1751 216.27 88.3989C209.968 83.1627 203.476 77.7607 199.401 76.4576L200.112 74.2068C204.613 75.6283 211.01 80.9593 217.763 86.5745C224.871 92.4741 232.927 99.1793 236.86 99.1793V101.549H236.883Z",
    fill: "url(#paint13_linear_7_29222)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5188 72.3587C43.3823 72.3587 39.2597 67.3831 34.9239 62.147C30.8487 57.2188 26.2285 51.6272 19.1206 48.9025L19.9736 46.6991C27.6501 49.6607 32.4835 55.4892 36.7483 60.6543C41.321 66.1748 44.9461 70.558 50.5376 69.942L50.7983 72.2876C50.3481 72.335 49.9216 72.3587 49.5188 72.3587Z",
    fill: "#F9D5FF"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1754 87.6644C28.9294 87.6644 25.7545 85.5557 22.9587 83.7077C21.3002 82.6178 19.7128 81.5753 18.4097 81.1251L19.1442 78.8743C20.7553 79.4192 22.4612 80.5328 24.2619 81.7175C26.9155 83.4708 29.6639 85.2714 32.1754 85.2714V87.6644Z",
    fill: "#F9D5FF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7_29222",
    x1: 101.843,
    y1: 119.737,
    x2: 49.2473,
    y2: 199.342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0DDFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9958,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7_29222",
    x1: 17.9355,
    y1: 196.491,
    x2: 70.1314,
    y2: 196.491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD8A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9958,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7_29222",
    x1: 106.508,
    y1: 218.564,
    x2: 118.594,
    y2: 195.061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.577493,
    stopColor: "#F5E8FF",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FDEEFF",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#CBE0FF",
    stopOpacity: 0.48
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_7_29222",
    x1: 145.728,
    y1: 189.318,
    x2: 240.319,
    y2: 189.318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD8A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9958,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_7_29222",
    x1: 94.8593,
    y1: 17.2121,
    x2: 94.8593,
    y2: 55.5987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#77879D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0893,
    stopColor: "#A1978E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1883,
    stopColor: "#C9A780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2791,
    stopColor: "#E5B275"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3578,
    stopColor: "#F7B96F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4155,
    stopColor: "#FDBB6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4989,
    stopColor: "#FDBB9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.599,
    stopColor: "#D1D2D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FECEAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_7_29222",
    x1: 108.852,
    y1: 17.2121,
    x2: 108.852,
    y2: 55.5987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#77879D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0893,
    stopColor: "#A1978E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1883,
    stopColor: "#C9A780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2791,
    stopColor: "#E5B275"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3578,
    stopColor: "#F7B96F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4155,
    stopColor: "#FDBB6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4989,
    stopColor: "#FDBB9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.599,
    stopColor: "#D1D2D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FECEAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_7_29222",
    x1: 70.4462,
    y1: 58.9276,
    x2: 89.5432,
    y2: 98.083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00456628,
    stopColor: "#88CBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#817FEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_7_29222",
    x1: 116.499,
    y1: 167.407,
    x2: 116.499,
    y2: 65.2061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE0C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.401,
    stopColor: "#7AAEFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5908,
    stopColor: "#B8C1FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2D4D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_7_29222",
    x1: 151.533,
    y1: 102.828,
    x2: 151.533,
    y2: 55.4413,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9774AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.401,
    stopColor: "#47A6D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5011,
    stopColor: "#A7A7AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5908,
    stopColor: "#E89AC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFE7D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_7_29222",
    x1: 126.799,
    y1: 104.96,
    x2: 126.799,
    y2: 51.7168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9774AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.401,
    stopColor: "#47A6D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5011,
    stopColor: "#A7A7AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5908,
    stopColor: "#E89AC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFE7D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_7_29222",
    x1: 139.158,
    y1: 172.727,
    x2: 139.158,
    y2: 70.5048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE0C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.401,
    stopColor: "#7AAEFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5908,
    stopColor: "#B8C1FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2D4D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_7_29222",
    x1: 145.295,
    y1: 102.828,
    x2: 145.295,
    y2: 55.4412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9774AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.401,
    stopColor: "#47A6D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5011,
    stopColor: "#A7A7AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5908,
    stopColor: "#E89AC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFE7D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_7_29222",
    x1: 54.6946,
    y1: 17.2121,
    x2: 54.6946,
    y2: 55.5987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#77879D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0893,
    stopColor: "#A1978E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1883,
    stopColor: "#C9A780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2791,
    stopColor: "#E5B275"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3578,
    stopColor: "#F7B96F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4155,
    stopColor: "#FDBB6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4989,
    stopColor: "#FDBB9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.599,
    stopColor: "#D1D2D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FECEAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_7_29222",
    x1: 185.77,
    y1: 119.32,
    x2: 217.74,
    y2: 81.5292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.577493,
    stopColor: "#F5E8FF",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FDEEFF",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#CBE0FF",
    stopOpacity: 0.48
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarginaliaDelivery);
export default __webpack_public_path__ + "static/media/marginalia-delivery.381d9ad7.svg";
export { ForwardRef as ReactComponent };